import { toMoney } from '@/utils/tools'
import { store } from '@/store'
import { i18n } from '@/i18n'

export const HEADERS_KEY_SET = new Set()

export class LabelStatistics {
  constructor ({ clientName, clientKey, margin, ...rest }) {
    this.total_count = 0
    this.total_expense = 0
    this.clientName = clientName
    this.clientKey = clientKey
    Object.keys(rest).forEach(key => {
      const value = rest[key]
      this[key] = value

      const keys = key.split('_')
      const type = keys.pop()
      HEADERS_KEY_SET.add(keys.join('_'))

      const itemMap = {
        count: 'total_count',
        expense: 'total_expense'
      }
      const itemValue = itemMap[type]
      if (itemValue) this[itemValue] = toMoney(this[itemValue] + value)
    })

    if (HEADERS_KEY_SET.has('JETSTAR') || HEADERS_KEY_SET.has('NEXTSLS')) {
      HEADERS_KEY_SET.delete('JETSTAR')
      HEADERS_KEY_SET.delete('NEXTSLS')
      HEADERS_KEY_SET.add('JETSTAR_total')
    }

    store.commit('setLabelStatisticHeaders', getStatisticsHeaders(HEADERS_KEY_SET))
  }

  // eslint-disable-next-line camelcase
  get JETSTAR_total_expense () {
    return (this.JETSTAR_expense || 0) + (this.NEXTSLS_expense || 0)
  }

  // eslint-disable-next-line camelcase
  get JETSTAR_total_count () {
    return (this.JETSTAR_count || 0) + (this.NEXTSLS_count || 0)
  }
}

export function getStatisticsHeaders (headersKeySet) {
  return [
    {
      sortable: false,
      text: i18n.t('organizationName'),
      value: 'name',
      width: '150px'
    },
    {
      sortable: false,
      text: i18n.t('department'),
      value: 'department',
      width: '150px'
    },
    {
      sortable: false,
      text: i18n.t('manager'),
      value: 'manager',
      width: '150px'
    },
    {
      sortable: true,
      text: i18n.t('total'),
      name: 'total',
      value: 'total_expense',
      width: '150px'
    },
    ...[...headersKeySet].map(key => ({
      sortable: true,
      text: key,
      value: `${key}_expense`,
      width: '150px'
    }))
  ]
}



// WEBPACK FOOTER //
// ./src/orm/models/LabelStatistics.js